<p-dialog
  maskStyleClass="backdrop-blur-sm"
  [visible]="true"
  styleClass="!border-0 !bg-transparent"
>
  <ng-template #headless>
    <div
      class="flex flex-col max-w-96 px-8 py-8 gap-6 rounded-2xl"
      style="
        border-radius: 12px;
        background-image: radial-gradient(
          circle at left top,
          var(--p-primary-400),
          var(--p-primary-700)
        );
      "
    >
      <img [src]="'/assets/logos/logo_name.svg'" class="w-40 mx-auto" />
      <div
        *ngIf="showEmail && formMode !== 'RESET'"
        class="inline-flex flex-col gap-2"
      >
        <label for="email" class="text-primary-50 font-semibold">
          {{ "login.username.label" | translate }}
        </label>
        <input
          pInputText
          id="email"
          [(ngModel)]="email"
          class="!bg-white/20 !border-0 !p-4 !text-primary-50 w-80"
        />
      </div>
      <div *ngIf="formMode === 'RESET'" class="inline-flex flex-col gap-2">
        <label for="code" class="text-primary-50 font-semibold">
          {{ "login.code.label" | translate }}
        </label>
        <input
          pInputText
          id="code"
          [(ngModel)]="code"
          class="!bg-white/20 !border-0 !p-4 !text-primary-50 w-80"
        />
      </div>
      <div
        *ngIf="showEmail && (formMode === 'LOGIN' || formMode === 'RESET')"
        class="inline-flex flex-col gap-2"
      >
        <label for="password" class="text-primary-50 font-semibold">{{
          "login.password.label" | translate
        }}</label>
        <input
          pInputText
          id="password"
          [(ngModel)]="password"
          class="!bg-white/20 !border-0 !p-4 !text-primary-50 w-80"
          type="password"
        />
      </div>
      <div *ngIf="errorMessage" class="flex; &quot;items-center&quot;: gap - 4">
        <p-message severity="error" class="w-full">{{
          errorMessage | translate
        }}</p-message>
      </div>
      <div
        *ngIf="successMessage"
        class="flex; &quot;items-center&quot;: gap - 4"
      >
        <p-message severity="success" class="w-full">{{
          successMessage | translate
        }}</p-message>
      </div>

      <div
        *ngIf="showEmail && formMode === 'LOGIN'"
        class="flex items-center gap-4"
      >
        <p-button
          [label]="'login.signIn' | translate"
          [disabled]="!isEmailValid()"
          (click)="sendLogin()"
          [loading]="sendingRequest"
          [text]="true"
          styleClass="!p-4 w-full !text-primary-50 !border !border-white/30 hover:!bg-white/10"
          class="w-full"
        />
      </div>

      <div *ngIf="formMode === 'FORGOT'" class="flex items-center gap-4">
        <p-button
          [label]="'login.requestPasswordReset.button' | translate"
          [disabled]="!isEmailValid()"
          (click)="requestPasswordReset()"
          [loading]="sendingRequest"
          [text]="true"
          styleClass="!p-4 w-full !text-primary-50 !border !border-white/30 hover:!bg-white/10"
          class="w-full"
        />
      </div>

      <div *ngIf="formMode === 'RESET'" class="flex items-center gap-4">
        <p-button
          [label]="'login.requestPasswordReset.button' | translate"
          [disabled]="!isEmailValid()"
          (click)="resetPassword()"
          [loading]="sendingRequest"
          [text]="true"
          styleClass="!p-4 w-full !text-primary-50 !border !border-white/30 hover:!bg-white/10"
          class="w-full"
        />
      </div>

      <ng-container *ngIf="formMode === 'FORGOT'">
        <div>
          <span
            (click)="formMode = 'LOGIN'; errorMessage = ''; successMessage = ''"
            class="text-primary-300 cursor-pointer"
            >{{ "login.goBackLabel" | translate }}</span
          >
        </div>
      </ng-container>
      <ng-container *ngIf="formMode === 'LOGIN'">
        <ng-container *ngIf="showEmail">
          <div>
            <span
              (click)="formMode = 'FORGOT'; errorMessage = ''"
              class="text-primary-300 cursor-pointer"
              >{{ "login.forgotPasswordLabel" | translate }}</span
            >
          </div>
          <div class="text-center !text-primary-50">
            {{ "login.orLabel" | translate }}
          </div>
        </ng-container>

        <img
          class="cursor-pointer"
          [ngStyle]="{ opacity: isMsalLoginDisabled() ? 0.6 : 1 }"
          [src]="'./assets/images/ms-symbollockup_signin_light.svg'"
          (click)="goToMsalLogin()"
        />
      </ng-container>
    </div>
  </ng-template>
</p-dialog>
